
import React from 'react';
import { Check } from 'lucide-react';

const BeginnerJourney = () => {
  const journeySteps = [
    {
      title: "Introduktion til klaveret",
      description: "I de første lektioner bliver du bekendt med klaveret, dets opbygning og grundlæggende teknikker.",
      points: [
        "Lær om klaviaturets opbygning med hvide og sorte tangenter",
        "Korrekt siddestilling og håndposition ved klaveret",
        "Grundlæggende fingerøvelser for at udvikle fingerstyrke og koordination",
        "Introduktion til enkle rytmer og taktarter"
      ]
    },
    {
      title: "Grundlæggende musikalske færdigheder",
      description: "Opbygger et solidt fundament af musikalske færdigheder, der er afgørende for din udvikling.",
      points: [
        "Introduktion til nodelæsning og musikalsk notation",
        "Forstå grundlæggende musikteori og akkorder",
        "Udvikle din evne til at spille med begge hænder samtidigt",
        "Lære at holde en stabil rytme og tempo"
      ]
    },
    {
      title: "Dit første repertoire",
      description: "Begynde at opbygge et repertoire af stykker, der passer til dit niveau og musikalske præferencer.",
      points: [
        "Spille enkle, kendte melodier tilpasset begynderniveau",
        "Introducere forskellige musikgenrer for at finde din stil",
        "Lære at øve effektivt derhjemme mellem lektionerne",
        "Udvikle din musikalske udtryksevne og dynamik"
      ]
    }
  ];

  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-serif font-bold mb-4">
              Din rejse som begynder ved klaveret
            </h2>
            <p className="text-lg text-gray-600">
              Når du starter med klaverundervisning hos mig, guider jeg dig gennem en struktureret læringsproces, 
              der sikrer en solid musikalsk udvikling og giver dig glæden ved at spille fra starten.
            </p>
          </div>
          
          <div className="space-y-12">
            {journeySteps.map((step, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 rounded-full bg-piano-gold flex items-center justify-center text-white font-bold mr-4">
                    {index + 1}
                  </div>
                  <h3 className="text-xl font-serif font-semibold">{step.title}</h3>
                </div>
                <p className="text-gray-600 mb-4">{step.description}</p>
                <ul className="space-y-2">
                  {step.points.map((point, i) => (
                    <li key={i} className="flex items-start">
                      <Check className="w-5 h-5 text-piano-gold mr-2 mt-0.5 flex-shrink-0" />
                      <span className="text-gray-700">{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          
          <div className="mt-12 bg-gray-50 p-6 rounded-lg border border-gray-200">
            <h3 className="text-xl font-serif font-semibold mb-4 text-center">Hvor lang tid tager det at lære klaver?</h3>
            <p className="text-gray-600">
              Som begynder vil du allerede efter de første 4-6 lektioner kunne spille enkle melodier. 
              Efter 3-6 måneder med regelmæssig undervisning og øvning vil du kunne spille flere stykker og 
              have en grundlæggende forståelse af klaverspil. Husk, at alle lærer i forskelligt tempo, og 
              din fremgang afhænger af din øvetid, motivation og naturlige anlæg. Det vigtigste er at nyde processen!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BeginnerJourney;
